var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditSecondaryOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.16406 1.66406H7.4974C3.33073 1.66406 1.66406 3.33073 1.66406 7.4974V12.4974C1.66406 16.6641 3.33073 18.3307 7.4974 18.3307H12.4974C16.6641 18.3307 18.3307 16.6641 18.3307 12.4974V10.8307",
    stroke: "#246BFD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.3675 2.5203L6.80088 9.08696C6.55088 9.33696 6.30088 9.82863 6.25088 10.187L5.89254 12.6953C5.75921 13.6036 6.40088 14.237 7.30921 14.112L9.81754 13.7536C10.1675 13.7036 10.6592 13.4536 10.9175 13.2036L17.4842 6.63696C18.6175 5.50363 19.1509 4.18696 17.4842 2.5203C15.8175 0.853629 14.5009 1.38696 13.3675 2.5203Z",
    stroke: "#246BFD",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.4219 3.46094C12.9802 5.4526 14.5385 7.01094 16.5385 7.5776",
    stroke: "#246BFD",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSecondaryOutlined);
export default __webpack_public_path__ + "static/media/edit-secondary-outlined.bdc4d8869ff2411a01c76c5a9206964b.svg";
export { ForwardRef as ReactComponent };